module.exports = __webpack_public_path__ + "img/hire3xai.440f1c2d.svg";